import { Location, LocationResponse } from '../types/location';
import { apiService } from './api';

export interface PaginatedResponse<T> {
  data: T[];
  total: number;
  page: number;
  per_page: number;
  total_pages: number;
}

export interface LocationListing {
  id: string;
  name: string;
  description: string;
  country: string;
  county: string;
  lat: number;
  lng: number;
  type: string;
  services: string[];
  location: string;
  rating?: number;
  price?: string;
  image?: string;
  plan?: string;
  galleryImages?: string[];
  operator?: {
    id: string;
    name: string;
    website?: string;
    // Add more fields as needed
  };
  // ...add other fields as needed
}

export interface LocationFilters {
  country?: string;
  county?: string;
  type?: string;
  search?: string;
  page?: number;
  per_page?: number;
  serviceTypes?: string[];
  placeTypes?: string[];
  experiences?: string[];
  amenities?: string[];
  showAll?: boolean;
  location?: string | { lat: number; lng: number; radius: number };
}

export const locationService = {
  getLocations: async (filters?: LocationFilters): Promise<LocationResponse> => {
    const response = await apiService.get('/locations', { params: filters, isPublic: true });
    return response;
  },

  getLocation: async (id: string): Promise<Location> => {
    const response = await apiService.get(`/locations/${id}`, { isPublic: true });
    return response;
  },

  createLocation: async (data: Partial<Location>): Promise<Location> => {
    const response = await apiService.post('/locations', data);
    return response;
  },

  updateLocation: async (id: string, data: Partial<Location>): Promise<Location> => {
    const response = await apiService.put(`/locations/${id}`, data);
    return response;
  },

  deleteLocation: async (id: string): Promise<void> => {
    await apiService.delete(`/locations/${id}`);
  }
};

export const fetchLocations = locationService.getLocations;
export const createLocation = locationService.createLocation;
export const updateLocation = locationService.updateLocation;
export const deleteLocation = locationService.deleteLocation;

export type { Location, LocationResponse }; 